import { AxiosError } from "axios";

export class ErrorWrapper extends Error {
  public name = "ErrorWrapper";
  public success: boolean;
  public status: number | boolean;
  public statusMessage: string;
  public raw: any;
  public isNetworkError: boolean;
  public isTimeout: boolean;

  constructor(error: AxiosError) {
    super();
    this.raw = error;
    this.stack = error.stack || this.stack;
    this.success = error.response?.data?.response?.success ?? false;
    this.status = error.response?.status ?? 0;
    this.statusMessage = this.getStatusMessage(
      typeof this.status === "number" ? this.status : 0
    );
    this.isNetworkError = this.checkIfNetworkError(error);
    this.isTimeout = this.checkIfTimeout(error);
    this.message = this.getResponseErrorMessage(error);
  }

  private getResponseErrorMessage(error: AxiosError): string {
    // Check for network-level errors first
    if (this.isTimeout) {
      return "Request timed out. Please check your connection and try again.";
    }

    if (this.isNetworkError) {
      return "Network connection failed. Please check your internet connection and try again.";
    }

    // For server response errors, use the server message
    return (
      error.response?.data?.response?.message ??
      error.message ??
      "An unexpected error occurred. Please try again."
    );
  }

  private checkIfNetworkError(error: AxiosError): boolean {
    // Check for various network error conditions
    return (
      !error.response &&
      (error.code === "NETWORK_ERROR" ||
        error.message === "Network Error" ||
        error.code === "ERR_NETWORK")
    );
  }

  private checkIfTimeout(error: AxiosError): boolean {
    return (
      error.code === "ECONNABORTED" ||
      error.code === "TIMEOUT" ||
      error.message.includes("timeout")
    );
  }

  private getStatusMessage(status: number): string {
    const successMsg = "Request Successful";
    const statusMessages: Record<number, string> = {
      200: successMsg,
      201: successMsg,
      400: "Bad Request",
      401: "Authentication Required",
      404: "Not Found",
      408: "Request Timeout",
      503: "Service Unavailable",
      504: "Gateway Timeout"
    };

    return statusMessages[status] ?? "Unknown Error";
  }
}
